import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';

@Component({
  selector: 'topo-switch',
  imports: [CommonModule, FormsModule, FlexLayoutModule],
  templateUrl: './switch.component.html',
  styleUrls: ['./switch.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: SwitchComponent
    }
  ]
})
export class SwitchComponent implements ControlValueAccessor {
  @Input() checked = false;
  @Output() checkChanged = new EventEmitter<boolean>();
  touched = false;
  @Input() disabled = false;
  onChange = value => {};
  onTouched = () => {};

  constructor() {}

  switchClick(): void {
    if (this.disabled) {
      return;
    }

    this.checked = !this.checked;
    this.checkChanged.emit(this.checked);
    this.markAsTouched();
    this.onChange(this.checked);
  }

  writeValue(checked: boolean) {
    this.checked = checked;
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }
}
